import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { FiShoppingBag, FiGrid, FiArrowRight } from 'react-icons/fi';
import StoreLayout from '../components/layout/StoreLayout';
import { getProducts } from '../redux/actions/productActions';
import { getCategories } from '../redux/actions/categoryActions';
import { addToCart } from '../redux/actions/cartActions';
import { getBarners } from '../redux/actions/barnnerActions';
import { getPublications } from '../redux/actions/publicationActions';
import PublicationsCarousel from '../components/web/publications/PublicationsCarousel';
import { responsivePublication } from '../config/dataApi';

const Index = () => {
  const dispatch = useDispatch();
  const { featuredProducts, newProducts, loading: productsLoading } = useSelector((state) => state.products);
  const { categories, loading: categoriesLoading } = useSelector((state) => state.categories);

  const loading = productsLoading || categoriesLoading;

  const { banners } = useSelector(state => state.banners);
  // publicitaire
  const { publications } = useSelector(state => state.publications);

  // Configuration responsive pour le carrousel
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1024 },
      items: 4,
      partialVisibilityGutter: 40
    },
    desktop: {
      breakpoint: { max: 1024, min: 768 },
      items: 3,
      partialVisibilityGutter: 30
    },
    tablet: {
      breakpoint: { max: 768, min: 464 },
      items: 2,
      partialVisibilityGutter: 20
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      partialVisibilityGutter: 10
    }
  };

  useEffect(() => {
    dispatch(getPublications());
    dispatch(getBarners());
    dispatch(getProducts());
    dispatch(getCategories());
  }, [dispatch]);

  const handleAddToCart = (product) => {
    dispatch(addToCart(product, 1));
  };


  const heroSlides = [
    {
      image: 'assets/images/barner-ordinateur.jpg',
      title: 'Bienvenue sur votre boutique en ligne',
      description: 'Découvrez notre sélection de produits de qualité à des prix compétitifs. Livraison rapide et service client exceptionnel.',
      cta: 'Voir tous les produits',
      link: '/products',
    },
    {
      image: 'assets/images/casque_VR.png',
      title: 'Offres spéciales',
      description: 'Profitez de nos offres exclusives et promotions limitées.',
      cta: 'En savoir plus',
      link: '/products',
    },
    {
      image: 'assets/images/barner-camera.jpg',
      title: 'Nouveautés de la saison',
      description: 'Explorez les dernières tendances et nouveautés disponibles dès maintenant.',
      cta: 'Découvrir',
      link: '/products',
    },

  ];


  const responsiveBarner = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1024 },
      items: 1,
      partialVisibilityGutter: 40
    },
    desktop: {
      breakpoint: { max: 1024, min: 768 },
      items: 1,
      partialVisibilityGutter: 30
    },
    tablet: {
      breakpoint: { max: 768, min: 464 },
      items: 1,
      partialVisibilityGutter: 20
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      partialVisibilityGutter: 10
    }
  };


  return (
    <StoreLayout>
      {/* Hero Section */}
      <Carousel
        responsive={responsiveBarner}
        autoPlay={true}
        infinite={true}
        showDots={false}
        containerClass="carousel-container"
      >
        {/* Cas 1 : Données en chargement */}
        {!banners ? (
          <div
            style={{
              height: '70vh',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: '#f8f9fa',
              color: '#6c757d',
              fontSize: '1.5rem'
            }}
          >
            <div className="text-center">
              <div className="spinner-border mb-3" role="status">
                <span className="visually-hidden">Chargement...</span>
              </div>
              <p>Chargement des slides en cours...</p>
            </div>
          </div>
        ) : banners.length === 0 ? (
          /* Cas 2 : Aucune bannière disponible */
          <div
            style={{
              height: '70vh',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: '#e9ecef',
              color: '#495057',
              textAlign: 'center',
              padding: '20px'
            }}
          >
            <div>
              <h3>Aucun slide disponible pour le moment</h3>
              <p>Nos promotions arrivent très bientôt !</p>
            </div>
          </div>
        ) : (
          /* Cas 3 : Afficher les slides */
          banners.map((slide, index) => (
            <div
              key={index}
              style={{
                position: 'relative',
                height: '70vh',
                backgroundImage: `url(${slide.imageUrl})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'rgba(0, 0, 0, 0.4)',
                  zIndex: 1,
                }}
              />
              <div
                style={{
                  position: 'relative',
                  zIndex: 2,
                  color: 'white',
                  textAlign: 'center',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  padding: '0 10px',
                }}
              >
                <h1 style={{ fontSize: '3rem', marginBottom: '1rem' }} className="text-white">
                  {slide.title || "Offre spéciale"}
                </h1>
                <p style={{ fontSize: '1.25rem', marginBottom: '2rem' }} className="text-white">
                  {slide.caption}
                </p>
                <a href={slide.linkUrl || "/products"} className="btn btn-light btn-lg">
                  Voir plus <FiArrowRight className="ms-2" />
                </a>
              </div>
            </div>
          ))
        )}
      </Carousel>


      {/* Categories Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="text-center h3 mb-4">Nos Catégories</h2>

          <div class="row my-4">

            <div className="col-md-7 mb-4">

              {categories && categories.length == 0 && categories.slice(0, 8).length == 0 ? (
                <div className="row my-4">
                  {[...Array(6)].map((_, index) => (
                    <div className="col-md-4 mb-4" key={index}>
                      <div
                        className="card border-0 shadow-sm h-100"
                        style={{
                          backgroundColor: "#f0f0f0",
                          // height: "300px",
                          borderRadius: "10px",
                          animation: "pulse 1.5s infinite",
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: "#e0e0e0",
                            height: "180px",
                            borderTopLeftRadius: "10px",
                            borderTopRightRadius: "10px",
                          }}
                        ></div>
                        <div className="p-3">
                          <div
                            style={{
                              height: "15px",
                              width: "70%",
                              backgroundColor: "#e0e0e0",
                              borderRadius: "5px",
                              marginBottom: "10px",
                            }}
                          ></div>
                          <div
                            style={{
                              height: "12px",
                              width: "50%",
                              backgroundColor: "#e0e0e0",
                              borderRadius: "5px",
                            }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  ))}
                  <style>
                    {`
        @keyframes pulse {
          0% { background-color: #f0f0f0; }
          50% { background-color: #e0e0e0; }
          100% { background-color: #f0f0f0; }
        }
      `}
                  </style>
                </div>
              ) : (
                <>
                  <div className="row g-4">
                    {categories.slice(0, 8).map((category) => (
                      <div key={category._id} className="col-md-6 col-lg-3">
                        <Link to={`/category/${category._id}`} className="card shadow-sm border h-100 text-decoration-none">
                          <div className="card-body d-flex flex-column align-items-center text-center">
                            <FiGrid className="fs-1 text-danger mb-3" />
                            <h5 className="card-title">{category.name}</h5>
                            <p className="card-text text-muted small">
                              {category.description || "Découvrez notre sélection"}
                            </p>
                          </div>
                        </Link>
                      </div>
                    ))}
                  </div>

                  {categories.length > 8 && (
                    <div className="text-center mt-4">
                      <Link to="/products" className="btn btn-outline-danger">
                        Voir toutes les catégories
                      </Link>
                    </div>
                  )}
                </>
              )}
            </div>



            {/* Publicités */}
            <div className="col-md-5 mb-4">
              {
                <PublicationsCarousel publications={publications} responsive={responsivePublication} />
              }
            </div>


          </div>



        </div>

      </section>

      {/* Featured Products Carousel */}
      <section className="py-5">
        <div className="container">
          <h2 className="text-center h3 mb-4">Produits en vedette</h2>

          {featuredProducts && featuredProducts.length == 0 ? (
            <div className="row my-4">
              {[...Array(3)].map((_, index) => (
                <div className="col-md-4 mb-4" key={index}>
                  <div
                    className="card border-0 shadow-sm h-100"
                    style={{
                      backgroundColor: "#f0f0f0",
                      // height: "300px",
                      borderRadius: "10px",
                      animation: "pulse 1.5s infinite",
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: "#e0e0e0",
                        height: "180px",
                        borderTopLeftRadius: "10px",
                        borderTopRightRadius: "10px",
                      }}
                    ></div>
                    <div className="p-3">
                      <div
                        style={{
                          height: "15px",
                          width: "70%",
                          backgroundColor: "#e0e0e0",
                          borderRadius: "5px",
                          marginBottom: "10px",
                        }}
                      ></div>
                      <div
                        style={{
                          height: "12px",
                          width: "50%",
                          backgroundColor: "#e0e0e0",
                          borderRadius: "5px",
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
              ))}
              <style>
                {`
        @keyframes pulse {
          0% { background-color: #f0f0f0; }
          50% { background-color: #e0e0e0; }
          100% { background-color: #f0f0f0; }
        }
      `}
              </style>
            </div>

          ) : (
            <Carousel
              responsive={responsive}
              autoPlay={true}
              duration={5000}
              infinite={true}
              showDots={false}
              containerClass="carousel-container"
              itemClass="px-2"
              dotListClass="custom-dot-list-style"
            >
              {featuredProducts.map((product) => (
                <div key={product._id} className="card h-100 shadow-sm">
                  <div className="position-relative">
                    {product.images && product.images.length > 0 ? (
                      <img
                        src={product.images[0]}
                        alt={product.name}
                        className="card-img-top"
                        style={{ height: '200px', objectFit: 'cover' }}
                      />
                    ) : (
                      <div className="card-img-top d-flex align-items-center justify-content-center bg-light" style={{ height: '200px' }}>
                        <FiShoppingBag className="text-muted fs-1" />
                      </div>
                    )}
                  </div>
                  <div className="card-body d-flex flex-column">
                    <Link to={`/product/${product._id}`} className="text-decoration-none text-dark">
                      <h5 className="card-title">{product.name}</h5>
                    </Link>
                    <p className="card-text text-muted flex-grow-1" style={{ minHeight: '48px' }}>
                      {product.description.substring(0, 60)}...
                    </p>
                    <div className="d-flex justify-content-between align-items-center">
                      <strong className="text-danger">{product.price.toFixed(0)} F</strong>
                      <button
                        onClick={() => handleAddToCart(product)}
                        className="btn btn-danger btn-sm"
                      >
                        Ajouter
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </Carousel>
          )}

          <div className="text-center mt-4">
            <Link to="/products" className="btn btn-outline-danger">
              Voir tous les produits
            </Link>
          </div>
        </div>
      </section>

      {/* New Products Carousel */}
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="text-center h3 mb-4">Nouveaux arrivages</h2>

          {newProducts && newProducts.length === 0 ? (
            <div className="row my-4">
              {[...Array(3)].map((_, index) => (
                <div className="col-md-4 mb-4" key={index}>
                  <div
                    className="card border-0 shadow-sm h-100"
                    style={{
                      backgroundColor: "#f0f0f0",
                      // height: "300px",
                      borderRadius: "10px",
                      animation: "pulse 1.5s infinite",
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: "#e0e0e0",
                        height: "180px",
                        borderTopLeftRadius: "10px",
                        borderTopRightRadius: "10px",
                      }}
                    ></div>
                    <div className="p-3">
                      <div
                        style={{
                          height: "15px",
                          width: "70%",
                          backgroundColor: "#e0e0e0",
                          borderRadius: "5px",
                          marginBottom: "10px",
                        }}
                      ></div>
                      <div
                        style={{
                          height: "12px",
                          width: "50%",
                          backgroundColor: "#e0e0e0",
                          borderRadius: "5px",
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
              ))}
              <style>
                {`
        @keyframes pulse {
          0% { background-color: #f0f0f0; }
          50% { background-color: #e0e0e0; }
          100% { background-color: #f0f0f0; }
        }
      `}
              </style>
            </div>
          ) : (
            <Carousel
              responsive={responsive}
              autoPlay={true}
              infinite={true}
              duration={11000}
              showDots={false}
              containerClass="carousel-container"
              itemClass="px-2"
            >
              {newProducts.map((product) => (
                <div key={product._id} className="card h-100 shadow-sm position-relative">
                  <div className="position-relative">
                    {product.images && product.images.length > 0 ? (
                      <img
                        src={product.images[0]}
                        alt={product.name}
                        className="card-img-top"
                        style={{ height: '200px', objectFit: 'cover' }}
                      />
                    ) : (
                      <div className="card-img-top d-flex align-items-center justify-content-center bg-light" style={{ height: '200px' }}>
                        <FiShoppingBag className="text-muted fs-1" />
                      </div>
                    )}
                    <span className="position-absolute top-0 start-0 m-2 badge bg-success">Nouveau</span>
                  </div>
                  <div className="card-body d-flex flex-column">
                    <Link to={`/product/${product._id}`} className="text-decoration-none text-dark">
                      <h5 className="card-title">{product.name}</h5>
                    </Link>
                    <p className="card-text text-muted flex-grow-1" style={{ minHeight: '48px' }}>
                      {product.description.substring(0, 60)}...
                    </p>
                    <div className="d-flex justify-content-between align-items-center">
                      <strong className="text-danger">{product.price.toFixed(0)} F</strong>
                      <button
                        onClick={() => handleAddToCart(product)}
                        className="btn btn-danger btn-sm"
                      >
                        Ajouter
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </Carousel>
          )}
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-5 bg-danger text-white">
        <div className="container text-center">
          <h2 className="h3 mb-3 text-white">Abonnez-vous à notre newsletter</h2>
          <p className="mb-4 text-white">
            Restez informé de nos derniers produits et offres spéciales.
          </p>
          <form className="d-flex flex-column flex-md-row gap-2 justify-content-center mb-4">
            <input
              type="email"
              placeholder="Votre adresse email"
              className="form-control w-md-50"
            />
            <button type="submit" className="btn btn-light">
              S'abonner
            </button>
          </form>
        </div>
      </section>
    </StoreLayout>
  );
};

export default Index;